import React from 'react'
import "./ProductSkeleton.css";

function ProductSkeleton() {

    return (
        <div className="product__skeleton">
            <div className="product__skeleton__info">
            <p style={{width:'100px',backgroundColor:'#CACACA',borderRadius:"20px"}}>&nbsp;</p>
            <p style={{width:'50px',backgroundColor:'#CACACA',borderRadius:"20px"}}>&nbsp;</p>
            </div>
            <h1 style={{backgroundColor:'#CACACA',borderRadius:"15px"}}  className='product__skeleton__image'>&nbsp;</h1>
       
            <button className='product__skeleton__button'> &nbsp;</button>
              
        </div>
    )
}

export default ProductSkeleton
